"use strict";
import { CSRF_HEADER, csrfToken } from "./csrf_token";
export function channelAuthorizationWithCsrf() {
  const token = csrfToken();
  return {
    transport: "ajax",
    endpoint: "/pusher/auth",
    headers: token === null ? {} : { [CSRF_HEADER]: token }
  };
}
